/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Phone_HintInputs */

const en_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best for booking and quick questions.`)
};

const es_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo mejor para reservar y preguntas rápidas.`)
};

const de_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am besten für Buchungen und schnelle Fragen.`)
};

const zh_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最适合预订和快速提问。`)
};

const ar_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأفضل للحجز والأسئلة السريعة.`)
};

const fr_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idéal pour la réservation et les questions rapides.`)
};

const vi_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tốt nhất để đặt chỗ và hỏi nhanh.`)
};

const sw_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bora kwa kuweka nafasi na maswali ya haraka.`)
};

const th_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดีที่สุดสำหรับการจองและคำถามด่วน`)
};

const bs_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najbolje za rezervacije i brza pitanja.`)
};

const ja_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご予約・お問い合わせ`)
};

const ko_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예약 및 빠른 질문.`)
};

const pt_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhor para reserva e perguntas rápidas.`)
};

const it_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideale per prenotazioni e domande veloci.`)
};

const sv_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bäst för bokning och snabba frågor.`)
};

const nl_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideaal voor boekingen en korte vragen.`)
};

const da_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedst til booking og hurtige spørgsmål.`)
};

const nb_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beste for booking og raske spørsmål.`)
};

const fi_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paras tapa varata tunti tai kysyä nopeasti.`)
};

const pl_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsze dla rezerwacji i szybkich pytań.`)
};

const ru_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучше всего для бронирования и быстрых вопросов.`)
};

const tr_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervasyon ve kısa sorular için en iyisi.`)
};

const hi_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बुकिंग और त्वरित प्रश्नों के लिए सर्वश्रेष्ठ।`)
};

const id_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling cocok untuk pemesanan dan pertanyaan singkat.`)
};

const ms_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaik untuk tempahan dan pertanyaan ringkas.`)
};

const cs_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší pro rezervaci a rychlé dotazy.`)
};

const el_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καλύτερα για κράτηση και γρήγορες ερωτήσεις.`)
};

const he_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכי מתאים להזמנות ולשאלות קצרות.`)
};

const af_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die beste vir besprekings en vinnige vrae.`)
};

const hu_contact_phone_hint = /** @type {(inputs: Contact_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglaláshoz és gyors kérdésekhez a legjobb.`)
};

/**
* | output |
* | --- |
* | "Best for booking and quick questions." |
*
* @param {Contact_Phone_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_phone_hint = /** @type {((inputs?: Contact_Phone_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Phone_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_phone_hint(inputs)
	if (locale === "de") return de_contact_phone_hint(inputs)
	if (locale === "zh") return zh_contact_phone_hint(inputs)
	if (locale === "ar") return ar_contact_phone_hint(inputs)
	if (locale === "fr") return fr_contact_phone_hint(inputs)
	if (locale === "vi") return vi_contact_phone_hint(inputs)
	if (locale === "sw") return sw_contact_phone_hint(inputs)
	if (locale === "th") return th_contact_phone_hint(inputs)
	if (locale === "bs") return bs_contact_phone_hint(inputs)
	if (locale === "ja") return ja_contact_phone_hint(inputs)
	if (locale === "ko") return ko_contact_phone_hint(inputs)
	if (locale === "pt") return pt_contact_phone_hint(inputs)
	if (locale === "it") return it_contact_phone_hint(inputs)
	if (locale === "sv") return sv_contact_phone_hint(inputs)
	if (locale === "nl") return nl_contact_phone_hint(inputs)
	if (locale === "da") return da_contact_phone_hint(inputs)
	if (locale === "nb") return nb_contact_phone_hint(inputs)
	if (locale === "fi") return fi_contact_phone_hint(inputs)
	if (locale === "pl") return pl_contact_phone_hint(inputs)
	if (locale === "ru") return ru_contact_phone_hint(inputs)
	if (locale === "tr") return tr_contact_phone_hint(inputs)
	if (locale === "hi") return hi_contact_phone_hint(inputs)
	if (locale === "id") return id_contact_phone_hint(inputs)
	if (locale === "ms") return ms_contact_phone_hint(inputs)
	if (locale === "cs") return cs_contact_phone_hint(inputs)
	if (locale === "el") return el_contact_phone_hint(inputs)
	if (locale === "he") return he_contact_phone_hint(inputs)
	if (locale === "af") return af_contact_phone_hint(inputs)
	if (locale === "hu") return hu_contact_phone_hint(inputs)
	return en_contact_phone_hint(inputs)
});